jQuery(document).ready(function($) {
  
  $("body").click(function(){            
    $('.owl-dot').attr("aria-label", "Dot");
    $('.slick-track').attr("aria-label", "Slick Slider");
  });
  
  $('.featured-product .product-vertical .slick-slider').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    prevArrow: $('.tvvertical-slider-pre'),
   	nextArrow: $('.tvvertical-slider-next'),
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: false,
    height: true,
    centerMode: false,
    focusOnSelect: true,
    autoplay: true,
    adaptiveHeight: true,
    vertical: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          adaptiveHeight: false,
          dots: true,
          prevArrow: '',
          nextArrow: '',
        }
      }
    ]
  });

  $('.main-product .product-vertical .slick-slider').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    prevArrow: $('.tvvertical-slider-pre'),
   	nextArrow: $('.tvvertical-slider-next'),
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: false,
    height: true,
    centerMode: false,
    focusOnSelect: true,
    autoplay: true,
    adaptiveHeight: true,
    vertical: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          adaptiveHeight: false,
          dots: true,
          prevArrow: '',
          nextArrow: '',
        }
      }
    ]
  });

  $('.tvcmsproduct-grid-list .tvproduct-grid').addClass('active');
  function removeClassesOfView() {
    $('#products').removeClass('grid grid-2 list list-2 catelog');
  }
  $(document).on('click', '.tvcmsproduct-grid-list .tvproduct-grid', function() {
    removeClassesOfView();
    $('#products').addClass('grid');
    // $('.tvgrid-list-view-product .tvproduct-wrapper.grid').balance();
    $('.tvcmsproduct-grid-list .tvproduct-grid-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-catalog').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-grid').addClass('active');
  });
  // End Grid View
  // Start Grid-2 View
  $(document).on('click', '.tvcmsproduct-grid-list .tvproduct-grid-2', function() {
    removeClassesOfView();
    $('#products').addClass('grid-2');
    // $('.tvgrid-list-view-product .tvproduct-wrapper.grid-2').balance();
    $('.tvcmsproduct-grid-list .tvproduct-grid').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-catalog').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-grid-2').addClass('active');
  });
  // End Grid-2 View
  // Start List View
  $(document).on('click', '.tvcmsproduct-grid-list .tvproduct-list', function() {
    removeClassesOfView();
    $('#products').addClass('list');
    $('.tvcmsproduct-grid-list .tvproduct-grid-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-catalog').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-grid').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list').addClass('active');
  });
  // End List View
  // Start List-2 View
  $(document).on('click', '.tvcmsproduct-grid-list .tvproduct-list-2', function() {
    removeClassesOfView();
    $('#products').addClass('list-2');
    $('.tvcmsproduct-grid-list .tvproduct-grid-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-catalog').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-grid').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list-2').addClass('active');
  });
  // End List-2 View
  // Start Catelog View
  $(document).on('click', '.tvcmsproduct-grid-list .tvproduct-catalog', function() {
    removeClassesOfView();
    $('#products').addClass('catelog');
    $('.tvcmsproduct-grid-list .tvproduct-grid').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-grid-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-list-2').removeClass('active');
    $('.tvcmsproduct-grid-list .tvproduct-catalog').addClass('active');
  });
  
});

function bottomTotop() {
  var startMenuStickyHeight = 250;
  var scrollHeight = $(document).scrollTop();
  if (scrollHeight > startMenuStickyHeight) {
    $('.tvbottom-to-top').fadeIn('slow');
  } else {
    $('.tvbottom-to-top').fadeOut('slow');
  }
}

function scrollToTop() {
  $('body,html').animate({
    scrollTop: 0 // Scroll to top of body
  }, 500);
}

$(document).on('click', '.tvbottom-to-top-icon', function() { // When arrow is clicked
  scrollToTop();
});